<div class="position-relative">
    <div [ngClass]="isCxone ? 'legacy-styles-section' : 'glaeSegmentHeader'" cvLocalizedText langSection="Games" langKey="Create_Folder_Title">Select or Create a Folder</div>
    <div [ngClass]="isCxone ? 'legacy-styles-sub-section' : 'glaeSegmentText'" cvLocalizedText langSection="Games" langKey="Create_Folder_Help">Select an existing folder, or you can add a new folder by typing a new folder name.</div>
        
    <div class="col-4 pl-0">
        <input type="text" class="form-control w-100" cvLocalizedPlaceholder langSection="Games" langKey="Folder_Placeholder" [(ngModel)]="gs.modified.item.underlyingRule.RuleFolder" (ngModelChange)="folderNameChanged()" list="existingFolders" maxlength="50"/>
        <datalist id="existingFolders" (change)="onFolderSelected($event)">
            <option *ngFor="let folder of getFolderList()" [value]="folder">
        </datalist>
    </div>
</div>
